export var BadgeStyle = {
    default: "orange",
    gray: "orange",
    green: "light",
    mint: "light",
    orange: "light"
};
export var selectBadgeStyle = function() {
    var style = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "default";
    return BadgeStyle[style];
};
